import React from 'react'
import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"


export default function officesColumn() {

	return [{
		name: "officesNameFilter",
		label: "Offices",
		options: {
			display: 'excluded',
			filterOptions: {
				logic: (officeArray, filterVal) => {
					if (!filterVal || !filterVal.length) return false
					return !officeArray.includes(filterVal[0])
				}
			}
		}
	}, {
		name: 'officesName',
		label: 'Offices',
		options: {
			filter: false,
			customBodyRowRenderLite: value => <AppOfficesBlockContainer rows={value} compact/>,
		}
	}]
}